export type AppReadyState = boolean;

const actionTypes = {
  SET_APP_READY: "SET_APP_READY",
} as const;

type AppReadyAction = {
  type: typeof actionTypes.SET_APP_READY;
};

const initialState: AppReadyState = false;

/* Actions */
const actions = {
  setAppReady: () => ({
    type: actionTypes.SET_APP_READY,
  }),
};

/* Reducer */
const reducer = (state: AppReadyState = initialState, action: AppReadyAction): AppReadyState => {
  switch (action.type) {
    case actionTypes.SET_APP_READY:
      return true;
    default:
      return state;
  }
};

export { reducer, actions };
